import { TELECONSULTORIA_SERVICE_CATEGORY } from "../constants";

/**
 * Canal gravado na extension `schedule-attendance-type` da agenda de teleconsultoria.
 * É vídeo: mantém "teleatendimento" para que as leituras existentes do legado
 * (sala Whereby, ícones, filtros) tratem a agenda como teleatendimento.
 * O que a diferencia é o `serviceCategory` teleconsultoria.
 */
export const TELECONSULTORIA_AGENDA_ATTENDANCE_TYPE = "teleatendimento";

/** CodeableConcept da categoria (HCS.category e Schedule.serviceCategory). */
function teleconsultoriaCategory() {
  return [
    {
      coding: [{ ...TELECONSULTORIA_SERVICE_CATEGORY }],
      text: TELECONSULTORIA_SERVICE_CATEGORY.display,
    },
  ];
}

/** Campos extras do HCS: `category` teleconsultoria (HCS tipado). */
export function teleconsultoriaHealthcareServiceExtras() {
  return { category: teleconsultoriaCategory() };
}

/**
 * Campos extras do Schedule:
 * - `serviceCategory` teleconsultoria;
 * - canal "teleatendimento" (ver acima);
 * - agenda sempre privada: não aparece na busca pública de pacientes.
 */
export function teleconsultoriaScheduleExtras() {
  return {
    serviceCategory: teleconsultoriaCategory(),
    attendanceType: TELECONSULTORIA_AGENDA_ATTENDANCE_TYPE,
    scheduleExposureEnabled: false,
  };
}
